import { Component, Element, h, Host, Prop } from "@stencil/core";
import { Logger } from "../../utils/console";

@Component({
    tag: "ux-notification-bell",
    styleUrl: "notification-bell.scss",
    shadow: true
})
export class NotificationBell {
    @Element() nativeElement!: HTMLUxNotificationBellElement;

    /**
     * Counter to display current notification number
     */
    @Prop() readonly counter: number = 0;

    public componentWillLoad() {
        if (!this.nativeElement.ariaLabel) {
            Logger("Accessibility error: 'aria-label' property is required for screen reader identification.", "warn");
        }
    }

    render() {
        return (
            <Host role="status">
                <div id="content">
                    <ux-icon id="icon" name="bell"></ux-icon>
                    {this.counter > 0 && (
                        <div id="badge">
                            <ux-badge>{this.counter > 99 ? "99+" : this.counter}</ux-badge>
                        </div>
                    )}
                </div>
            </Host>
        );
    }
}
